import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-settings",
  templateUrl: "./settings.component.html",
  styleUrls: ["./settings.component.scss"],
})
export class SettingsComponent {
  readonly tabs: INavTab[] = [
    { routerLink: "/settings/profile", label: "profile" },
    { routerLink: "/settings/filters", label: "filters" },
    { routerLink: "/settings/password", label: "password" },
    { routerLink: "/settings/notifications", label: "notifications" },
    { routerLink: "/settings/usage-summary", label: "usage summary" },
  ];

  constructor(private readonly _router: Router) {}

  isCurrentUrlEquals(url: string) {
    return this._router.url === url;
  }
}

interface INavTab {
  routerLink: string;
  label: string;
}
